import React from 'react';
import ReactDOM from 'react-dom';

import { PasswordStrengthMeter } from '@/components/molecules/PasswordStrengthMeter';

document.addEventListener('turbolinks:load', () => {
  const element = document.querySelector<HTMLInputElement>('[data-behavior="password-meter"]');
  if (!element) {
    return;
  }

  const { target } = element.dataset;

  ReactDOM.render(<PasswordStrengthMeter target={target} />, element);
});
